import { render } from "./BalancerSystemControl.vue?vue&type=template&id=21796028&scoped=true"
import script from "./BalancerSystemControl.vue?vue&type=script&lang=js"
export * from "./BalancerSystemControl.vue?vue&type=script&lang=js"

import "./BalancerSystemControl.vue?vue&type=style&index=0&id=21796028&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21796028"]])

export default __exports__